import {
  IS_TESTING_ENVIRONMENT,
  PROD_GRAPHQL_GATEWAY_URL,
  QA_GRAPHQL_GATEWAY_URL,
} from '../constants/environment';

export const getGraphqlGatewayUrl = () => {
  return IS_TESTING_ENVIRONMENT ? QA_GRAPHQL_GATEWAY_URL : PROD_GRAPHQL_GATEWAY_URL;
};
